import React, { useState, useEffect } from "react";
import { Draggable } from "@hello-pangea/dnd";
import { Trash2, ChevronUp, ChevronDown, Grip, Upload } from "lucide-react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Select from "react-select";
import Dropdown from "@/components/ui/Dropdown";
import ConfirmationDialog from "@/components/Common/ConfirmationDialog";

export function FormComponent({
  field,
  index,
  onDelete,
  onMove,
  onSelect,
  isSelected,
  isFirst,
  isLast,
  onDuplicate,
}) {
  const [imagePreview, setImagePreview] = useState(null);
  const [editorContent, setEditorContent] = useState("");

  const handleMove = (direction, e) => {
    e.stopPropagation();
    onMove(field.id, direction);
  };
  useEffect(() => {
    if (!editorContent) {
      setEditorContent(field.placeholder);
    }
  }, [field.placeholder]);

  const renderField = () => {
    switch (field.type) {
      case "number":
        return (
          <div>
            {field.sublabel && (
              <p className="text-sm text-muted-foreground mb-1">{field.sublabel}</p>
            )}
            {/* <div className="flex"> */}
            {/* {field.countryCode && (
                <div className="flex-shrink-0">
                  <select
                    value={field.countryCode}
                    className="h-full px-3 py-2 bg-muted border border-r-0 border-input rounded-l-md"
                    disabled
                  >
                    <option>{field.countryCode}</option>
                  </select>
                </div>
              )} */}
            {/* <div className="flex-grow"> */}
            <input
              type="number"
              className="w-full px-3 py-2 border border-input rounded-md"
              placeholder={field.placeholder}
              // {...(field.inputMask ? { pattern: field.inputMask } : {})}
            />
            {/* </div> */}
            {/* </div> */}
            {/* {field.areaCodePlaceholder && field.phonePlaceholder && (
              <div className="grid grid-cols-2 gap-2 mt-2">
                <input
                  type="text"
                  className="px-3 py-2 border border-input rounded-md"
                  placeholder={field.areaCodePlaceholder}
                />
                <input
                  type="text"
                  className="px-3 py-2 border border-input rounded-md"
                  placeholder={field.phonePlaceholder}
                />
              </div>
            )} */}
          </div>
        );
      case "wysiwyg":
      case "textarea":
        return (
          <div>
            {field.sublabel && (
              <p className="text-sm text-muted-foreground mb-1">{field.sublabel}</p>
            )}
            <textarea
              className="w-full px-3 py-2 border border-input rounded-md"
              placeholder={field.placeholder}
              rows={4}
            />
          </div>
        );

      case "select":
        return (
          <div>
            {field.sublabel && (
              <p className="text-sm text-muted-foreground mb-1">{field.sublabel}</p>
            )}

            <Dropdown
              className="w-full"
              options={(() => {
                let options = [];
                if (Array.isArray(field.options)) {
                  options = field.options.map((option) => ({
                    value: option.value || option.label,
                    label: option.label || option,
                  }));
                } else if (typeof field.options === "string") {
                  options = field.options.split(",").map((opt) => ({
                    value: opt.trim(),
                    label: opt.trim(),
                  }));
                }
                return options;
              })()}
              placeholder="Select an option"
              onChange={(selectedOption) => {
                // Handle the change event
                console.log(selectedOption);
              }}
              searchable={true}
            />
          </div>
        );
      case "radio":
        return (
          <div>
            {field.sublabel && (
              <p className="text-sm text-muted-foreground mb-1">{field.sublabel}</p>
            )}
            <div className="space-y-2">
              {(() => {
                let options = [];
                // If field.options is an array, use it directly.
                // If it's a string, split it into an array.
                if (Array.isArray(field.options)) {
                  options = field.options;
                } else if (typeof field.options === "string") {
                  options = field.options.split(",").map((opt) => opt.trim());
                }
                return options.map((option, idx) => {
                  // In case the option is a simple string, create an object.
                  const optionData =
                    typeof option === "object"
                      ? option
                      : { label: option, value: option };
                  return (
                    <div key={idx} className="flex items-center">
                      <input
                        type="radio"
                        id={`radio-${field.id}-${idx}`}
                        name={`radio-${field.id}`}
                        value={optionData.value}
                        className="w-4 h-4 text-foreground border-brand focus:ring-brand"
                        // {...(field.is_required ? { required: true } : {})}
                      />
                      <label
                        htmlFor={`radio-${field.id}-${idx}`}
                        className="ml-2 text-sm text-foreground"
                      >
                        {optionData.label}
                      </label>
                    </div>
                  );
                });
              })()}
            </div>
          </div>
        );
      case "checkbox":
        return (
          <div>
            {field.sublabel && (
              <p className="text-sm text-muted-foreground mb-1">{field.sublabel}</p>
            )}
            <div className="space-y-2">
              {(() => {
                let options = [];
                // If field.options is an array, use it directly.
                // If it's a string, split it into an array.
                if (Array.isArray(field.options)) {
                  options = field.options;
                } else if (typeof field.options === "string") {
                  options = field.options.split(",").map((opt) => opt.trim());
                }
                return options.map((option, idx) => {
                  // In case the option is a simple string, create an object.
                  const optionData =
                    typeof option === "object"
                      ? option
                      : { label: option, value: option };
                  return (
                    <div key={idx} className="flex items-center">
                      <input
                        type="checkbox"
                        id={`checkbox-${field.id}-${idx}`}
                        name={`checkbox-${field.id}`}
                        value={optionData.value}
                        className="w-4 h-4 text-foreground border-brand focus:ring-brand"
                        // {...(field.is_required ? { required: true } : {})}
                      />
                      <label
                        htmlFor={`checkbox-${field.id}-${idx}`}
                        className="ml-2 text-sm text-foreground"
                      >
                        {optionData.label}
                      </label>
                    </div>
                  );
                });
              })()}
            </div>
          </div>
        );

      // Handle Upload File – supports both "file" and "image"
      case "file":
      case "image":
        return (
          <div>
            {field.sublabel && (
              <p className="text-sm text-muted-foreground mb-1">{field.sublabel}</p>
            )}
            {imagePreview ? (
              <div
                className={`relative group text-${field.alignment || "left"}`}
              >
                <img
                  src={imagePreview}
                  alt="Preview"
                  className={`max-w-full h-auto rounded-lg ${field.size ? `w-${field.size}` : ""}`}
                />
                <button
                  onClick={() => setImagePreview(null)}
                  className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            ) : (
              <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-input rounded-lg cursor-pointer hover:border-blue-500 transition-colors">
                <Upload className="w-8 h-8 text-muted-foreground mb-2" />
                <span className="text-sm text-muted-foreground">Choose a file</span>
                <input
                  type="file"
                  className="hidden"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      const reader = new FileReader();
                      reader.onloadend = () => setImagePreview(reader.result);
                      reader.readAsDataURL(file);
                    }
                  }}
                />
              </label>
            )}
          </div>
        );

      case "heading":
        return (
          <div>
            <h2
              className={`
              ${
                field.headingSize === "large"
                  ? "text-2xl"
                  : field.headingSize === "small"
                    ? "text-lg"
                    : "text-xl"
              }
              font-bold text-foreground
            `}
            >
              {field.label || ""}
            </h2>
            {field.sublabel && (
              <p className="mt-1 text-muted-foreground">{field.sublabel}</p>
            )}
          </div>
        );

      case "spacer":
        return <hr className="my-4 border-t border-border" />;

      case "_wysiwyg":
        return (
          <div className="mt-2">
            {field.sublabel && (
              <p className="text-sm text-muted-foreground mb-1">{field.sublabel}</p>
            )}
            <ReactQuill
              onChange={setEditorContent}
              placeholder={field.placeholder}
              key={field.placeholder}
              className="bg-card"
              theme="snow"
              modules={{
                toolbar: [
                  ["bold", "italic", "underline", "strike"],
                  ["blockquote", "code-block"],
                  [{ header: 1 }, { header: 2 }],
                  [{ list: "ordered" }, { list: "bullet" }],
                  [{ script: "sub" }, { script: "super" }],
                  [{ indent: "-1" }, { indent: "+1" }],
                  [{ color: [] }, { background: [] }],
                  ["link", "image"],
                  ["clean"],
                ],
              }}
            />
          </div>
        );

      case "text":
        return (
          <div>
            {field.sublabel && (
              <p className="text-sm text-muted-foreground mb-1">{field.sublabel}</p>
            )}
            <input
              type="text"
              className="w-full px-3 py-2 border border-input rounded-md"
              placeholder={field.placeholder}
            />
          </div>
        );

      case "email":
        return (
          <div>
            {field.sublabel && (
              <p className="text-sm text-muted-foreground mb-1">{field.sublabel}</p>
            )}
            <input
              type="email"
              className="w-full px-3 py-2 border border-input rounded-md"
              placeholder={field.placeholder}
            />
          </div>
        );

      case "phone":
        return (
          <div>
            {field.sublabel && (
              <p className="text-sm text-muted-foreground mb-1">{field.sublabel}</p>
            )}
            <input
              type="tel"
              className="w-full px-3 py-2 border border-input rounded-md"
              placeholder={field.placeholder}
              onInput={(e) => {
                // Allow numbers (0-9), dashes (-), and spaces
                // Numbers allowed: 0, 1, 2, 3, 4, 5, 6, 7, 8, 9
                const input = e.target.value.replace(/[^0-9\- ]/g, "");
                e.target.value = input;
              }}
            />
          </div>
        );

      case "date":
        return (
          <div>
            {field.sublabel && (
              <p className="text-sm text-muted-foreground mb-1">{field.sublabel}</p>
            )}
            <input
              type="date"
              className="w-full px-3 py-2 border border-input rounded-md"
              placeholder={field.placeholder}
            />
          </div>
        );

      case "university_repeatable":
        return (
          <div>
            {field.sublabel && (
              <p className="text-sm text-muted-foreground mb-1">{field.sublabel}</p>
            )}
            <div className="p-2 border-2 border-dashed border-input rounded-lg bg-muted">
              <div className="">
                <p className="text-muted-foreground text-sm ">
                  Please enter your university details
                </p>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <Draggable
      draggableId={`form-component-draggable-${field.id}`}
      index={index}
    >
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          onClick={() => onSelect(field.id)}
          className={`
            group bg-card p-4 rounded-lg shadow-sm border border-brand/20 
            ${snapshot.isDragging ? "shadow-lg ring-2 ring-[#003423] ring-offset-2" : ""}
            ${isSelected ? "ring-2 ring-[#003423]" : ""}
            hover:shadow-md transition-all duration-200 relative cursor-pointer
          `}
        >
          {/* Control buttons */}
          <div className="absolute right-2 top-2 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
            {/* Add Duplicate button */}
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onDuplicate(field);
              }}
              className="p-1 hover:bg-muted rounded text-foreground transition-colors"
              title="Duplicate field"
            >
              <svg
                className="w-4 h-4"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                />
              </svg>
            </button>

            {!isFirst && (
              <button
                type="button"
                onClick={(e) => handleMove("up", e)}
                className="p-1 hover:bg-muted rounded text-foreground transition-colors"
                title="Move up"
              >
                <ChevronUp className="w-4 h-4" />
              </button>
            )}
            {!isLast && (
              <button
                type="button"
                onClick={(e) => handleMove("down", e)}
                className="p-1 hover:bg-[F4F4F5] rounded text-foreground transition-colors"
                title="Move down"
              >
                <ChevronDown className="w-4 h-4" />
              </button>
            )}
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                console.log(
                  "FormComponent delete button clicked for field:",
                  field.id,
                );
                onDelete(field.id);
              }}
              className="p-1 hover:bg-red-50 text-red-500 rounded transition-colors"
              title="Delete field"
            >
              <Trash2 className="w-5 h-5" />
            </button>
            <div
              {...provided.dragHandleProps}
              className="p-1 hover:bg-muted rounded cursor-move"
              title="Drag to reorder"
            >
              <Grip className="w-4 h-4 text-muted-foreground" />
            </div>
          </div>

          {/* Display field label only if the field type is neither spacer nor heading */}
          {field.type !== "spacer" && field.type !== "heading" && (
            <div className="mb-2">
              <label className="block text-sm font-medium text-foreground">
                {field.label}
                {field.is_required && (
                  <span className="text-red-500 ml-1">*</span>
                )}
              </label>
            </div>
          )}

          {renderField()}
        </div>
      )}
    </Draggable>
  );
}

// Wrapper component to handle the confirmation dialog outside of Draggable context
export function FormComponentWithDialog(props) {
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

  // Check if the current field is being used in smart rules
  const isFieldUsedInSmartRules = () => {
    if (!props.smartRules || props.smartRules.length === 0) {
      return false;
    }

    const fieldLabel = props.field.question || props.field.label;
    return props.smartRules.some((rule) => rule.field === fieldLabel);
  };

  const handleDelete = (fieldId) => {
    console.log(
      "Delete button clicked, showing confirmation dialog for field:",
      fieldId,
    );
    setShowDeleteConfirmation(true);
  };

  const handleConfirmDelete = () => {
    console.log("Confirming delete for field:", props.field.id);
    props.onDelete(props.field.id);
  };

  return (
    <>
      <FormComponent {...props} onDelete={handleDelete} />
      <ConfirmationDialog
        isOpen={showDeleteConfirmation}
        onClose={() => setShowDeleteConfirmation(false)}
        onConfirm={handleConfirmDelete}
        title="Delete Field"
        message={
          isFieldUsedInSmartRules()
            ? "You can not delete this field as this is being used in smart rules. Please review the smart rules first"
            : "Are you sure you want to delete this field? This action cannot be undone."
        }
        cancelText="Cancel"
        isDestructive={true}
        showConfirmButton={!isFieldUsedInSmartRules()} // Hide confirm button only if field is used in smart rules
      />
    </>
  );
}

FormComponent.defaultProps = {
  onDelete: () => console.warn("onDelete function not provided"),
  onMove: () => console.warn("onMove function not provided"),
  onSelect: () => console.warn("onSelect function not provided"),
  onDuplicate: () => console.warn("onDuplicate function not provided"),
};
